module.exports = __webpack_public_path__ + "static/media/intothegreat.0cb262d1.jpg";